import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-chat-question',
  imports: [],
  templateUrl: './chat-question.component.html',
  styleUrl: './chat-question.component.scss'
})
export class ChatQuestionComponent {
  @Input({required: true}) content!: string;

}
